import moment from "moment";
import {
  UP_SELL_LOADING,
  SET_UP_SELL_TYPES,
  SET_UP_SELL_SUBTYPES,
  SET_UP_SELL_COUNTS,
  RESET_REPORTS,
  ADD_UP_SELL_ERROR,
} from "../constants";
import { UP_SELL_QUERY_TOKEN } from "../actions/upSellActions";

let SAVED_STATE = JSON.parse(sessionStorage.getItem(UP_SELL_QUERY_TOKEN));
if (SAVED_STATE && moment().isAfter(SAVED_STATE.expires_at)) {
  SAVED_STATE = null;
}

const initial_state = {
  errors: {},
  loading: {},

  // User selected options
  options: {
    startDateTime: moment().subtract(1, "day").startOf("day"), // Default: start of yesterday
    endDateTime: moment().endOf("day"), // Default: through today
    expires_at: moment().add(1, "hour").toJSON(),
    ...SAVED_STATE,
  },

  // Options for dropdowns
  types: [], // "BILL_TO_DATE", "DISCONNECT", "EBILL", ...
  subTypes: [], // "COMPLETE", "NEW", "PAYMENT_RECEIVED", ...

  // Display Data based on selections above
  counts: [
    /* {type_vch: String, subtype_vch: String, count: Number}, ... */
  ],
};

export default function (state = initial_state, { type, payload, name }) {
  let { loading, errors } = state;

  switch (type) {
    case UP_SELL_LOADING:
      loading[payload] = true;

      return {
        ...state,
        loading: { ...loading },
      };

    case ADD_UP_SELL_ERROR:
      // If provided, clear loading
      name && (loading[name] = false);

      if (payload.message) {
        payload = {
          [name]: "There was a problem. Please try again later",
        };
      }

      // Set errors
      errors = {
        ...errors,
        ...payload,
      };
      return {
        ...state,
        errors,
        loading: { ...loading },
      };

    case SET_UP_SELL_TYPES:
      loading["types"] = false;
      delete errors["types"];

      return {
        ...state,
        errors: { ...errors },
        loading: { ...loading },
        types: payload || [],
      };

    case SET_UP_SELL_SUBTYPES:
      loading["subTypes"] = false;
      delete errors["subTypes"];

      return {
        ...state,
        errors: { ...errors },
        loading: { ...loading },
        subTypes: payload || [],
      };

    case SET_UP_SELL_COUNTS:
      loading["counts"] = false;
      delete errors["counts"];

      return {
        ...state,
        errors: { ...errors },
        loading: { ...loading },
        counts: payload || [],
      };

    case RESET_REPORTS:
      return { ...initial_state };

    default:
      return state;
  }
}
